import { render, staticRenderFns } from "./IconClassProgram.vue?vue&type=template&id=65715cac"
import script from "./IconClassProgram.vue?vue&type=script&lang=js"
export * from "./IconClassProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports